import { useQuery } from '@tanstack/vue-query'

export type AttemptedPackage = {
  id: string
  name: string
  tier: string | null
  billingPeriod: string | null
  price: number
}

export const useAttemptedPackage = () => {
  const authStore = useAuthStore()

  return useQuery({
    queryKey: ['attempted-package', authStore.getUser?.id],
    queryFn: async () => {
      const response = await $fetch<{ success: boolean; data: AttemptedPackage | null }>(
        '/api/payment/attempted-package',
        {
          headers: {
            Authorization: `Bearer ${authStore.token}`,
          },
        }
      )
      return response.data
    },
    enabled: computed(() => !!authStore.getUser?.id),
    staleTime: 1000 * 60 * 5,
  })
}

export default useAttemptedPackage

